import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import { Field } from 'formik';
import BooleanToggle from '@/components/forms/new/formikFormFields/BooleanToggle';
import TriggerFieldToolTip from './TriggerFieldToolTip';
import { useTriggerForm } from '../useTriggerForm.js';
import { FORM_FIELD_PATHS } from '../triggerFormConstants.js';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
} from 'components/forms/new/formStyles';
import walkthroughIds from '../../walkthroughIds';

const TriggerEnabled = ({ darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { editMode } = walkthroughIds;

    // Use context instead of Redux
    const { formData, updateFormData } = useTriggerForm();

    const handleToggleChange = (value) => {
        updateFormData(FORM_FIELD_PATHS.ENABLED, value);
    };

    return (
        <FormControl
            sx={{ margin: '0 !important', position: 'relative' }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack
                direction="row"
                spacing={stackSpacing}
                sx={{ ...stackStyling(), height: 'auto' }}>
                <FormLabel htmlFor="enabled" sx={formLabelStyling(darkMode)}>
                    Enabled
                </FormLabel>
                <Box flex={1} maxWidth="400px">
                    <Field
                        component={BooleanToggle}
                        id="enabled"
                        name="enabled"
                        paddingTop="20px"
                        isChecked={formData?.enabled ?? true}
                        onChange={handleToggleChange}
                        walkthroughId={editMode.ufEnabledToggle}
                    />
                    <TriggerFieldToolTip
                        isVisible={isHovered}
                        label="Enable or disable this trigger"
                        ariaLabel="trigger-enabled-tip"
                    />
                </Box>
            </Stack>
        </FormControl>
    );
};

export default TriggerEnabled;
